import { lazy, type ComponentType } from "react";

export function isRouteModuleLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error || "");
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message);
}

/** An open tab can outlive a deployment that removed its unvisited chunks.
 * Fetch fresh HTML once, preserving the route and authenticated session. Never
 * reload for application errors or loop when the network remains unavailable. */
export function lazyRoute<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try { return await load(); }
    catch (error) {
      if (!isRouteModuleLoadError(error)) throw error;
      const key = "portal_route_module_recovery";
      try {
        const last = Number(sessionStorage.getItem(key) || 0);
        if (Date.now() - last < 5 * 60_000) throw error;
        sessionStorage.setItem(key, String(Date.now()));
      } catch { throw error; }
      window.location.reload();
      // Keep Suspense's shell mounted while the new document loads.
      return await new Promise<{ default: T }>(() => {});
    }
  });
}
